


import SECTION_COMMISSIONPLAN_TITLE_D from
'../dynamic_section/dynamic_2/template_01';






import CommissionPlanSection from '../sections/commission_plan/default';






import SECTION_COMMISSIONPLAN from
'../dynamic_section/dynamic_2/template_01';





import SECTION_COMMISSIONPLAN_M from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";

const CommissionPlanPage = ()=>{
return (
<div id="commissionPlanPage" className="page">
  
  

  
  < SECTION_COMMISSIONPLAN_TITLE_D desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `commissionPlan_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
{/*   
  < SECTION_COMMISSIONPLAN_TITLE_D desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `commissionPlan_title_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  < SECTION_COMMISSIONPLAN desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `commissionPlan` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  

  < SECTION_COMMISSIONPLAN_M desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `commissionPlan_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } /> */}
  
  <CommissionPlanSection />
  
  
  
  

  
  < SECTION_COMMISSIONPLAN desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `commissionPlan` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  
  
  

  
  < SECTION_COMMISSIONPLAN_M desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `commissionPlan_m` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
</div>
)
}

export default CommissionPlanPage;